// extracted by mini-css-extract-plugin
export default {"divider":"FoodDetail_divider__rWvye"};